import { Mic, Video, FileText, Radio, MessageSquare, Landmark } from "lucide-react";
import { SOURCE_LABEL } from "@/lib/utils";

const ICONS = {
  keynote: FileText,
  earnings_call: Landmark,
  podcast: Mic,
  interview: MessageSquare,
  youtube: Video,
};

// SEC-filed sources get a distinct amber/regulatory accent so users can tell
// at a glance that this quote came from a legally-accountable filing rather
// than a podcast or YouTube upload. Every other source keeps the neutral
// slate-grey treatment.
const CLASS_BY_SOURCE = {
  earnings_call:
    "inline-flex items-center gap-1.5 border border-[#f59e0b]/40 bg-[#f59e0b]/10 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-[#f59e0b]",
};
const ICON_TINT_BY_SOURCE = {
  earnings_call: "text-[#f59e0b]",
};
const DEFAULT_CLASSNAME =
  "inline-flex items-center gap-1.5 border border-[#1e293b] bg-[#0f172a] px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider text-[#94a3b8]";

export default function SourceBadge({ source, sourceName }) {
  const Icon = ICONS[source] || Radio;
  const wrapperClass = CLASS_BY_SOURCE[source] || DEFAULT_CLASSNAME;
  const iconTint = ICON_TINT_BY_SOURCE[source] || "text-[#3b82f6]";
  return (
    <span
      data-testid={`source-badge-${source}`}
      className={wrapperClass}
      title={
        source === "earnings_call"
          ? "SEC-filed — quote is drawn from a publicly-filed regulatory document (8-K exhibit or earnings transcript)"
          : undefined
      }
    >
      <Icon className={`h-3 w-3 ${iconTint}`} />
      <span>{SOURCE_LABEL[source] || source}</span>
      {sourceName ? (
        <span
          className={
            source === "earnings_call" ? "text-[#f59e0b]/60" : "text-[#64748b]"
          }
        >
          · {sourceName}
        </span>
      ) : null}
    </span>
  );
}
